<template>
    <div class="foot_section flexjccenter">
      <div class="foot_wrap">
        <div class="foot_flex">
          <img class="foot_logo" :src="footerInfo.componyInfo.logoValue" />
        </div>
        <p class="foot_href" v-if="footerInfo.linkList.length>0">友情链接</p>
        <ul class="flex flexwrap" v-if="footerInfo.linkList.length>0">
          <li class="link_item" v-for="(item, index) in footerInfo.linkList" :key="index">
            <span @click="gotoLink(item)">{{item.linkName}}</span>
          </li>
        </ul>
        <div class="foot_outconcat">
          <div>
            <p class="foot_concat">联系我们</p>
            <div class="footflex">
              <div class="foot_telbox">
                <div class="foot_telline">公司行政：{{footerInfo.componyInfo.xzMobileValue}}</div>
                <div>工作时间：{{footerInfo.componyInfo.workTimeValue}}</div>
              </div>
              <div class="foot_telbox">
                <div class="flex foot_telline">商城客服：{{footerInfo.componyInfo.kfMobileValue}}
                  <div v-if="footerInfo.componyInfo.kfWxValue">
                    <div class="pconline">
                      <el-popover
                        placement="top"
                        width="200"
                        trigger="hover">
                        <div class="flexcenter">
                          <div class="pover_code">
                            <img :src="footerInfo.componyInfo.kfWxValue" />
                          </div>
                        </div>
                        <div class="foot_online" slot="reference">在线联系客服</div>
                      </el-popover>
                    </div>
                    <div class="smallonline">
                      <div class="foot_online" @click="previewImg(footerInfo.componyInfo.kfWxValue)">在线联系客服</div>
                    </div>
                  </div>
                </div>
                <div>公司地址：{{footerInfo.componyInfo.addressValue}}</div>
              </div>
            </div>
          </div>
          <div class="flex tacenter pcfoot">
            <div v-if="wxcodeList.length>0">
              <el-popover
                placement="top"
                width="350"
                trigger="hover">
                <div class="flexcenter">
                  <div class="pover_code" v-for="(item, index) in wxcodeList" :key="index">
                    <img :src="item.url" />
                    <p>{{item.name}}</p>
                  </div>
                </div>
                <div class="foot_outone" slot="reference">
                  <span class="iconfont icon-weixin foot_icon"></span>
                  <p style="margin-top: 6px;">微信</p>
                </div>
              </el-popover>
            </div>
            <div v-if="dycodeList.length>0">
              <el-popover
                placement="top"
                trigger="hover">
                <div class="flexcenter">
                  <div class="pover_code" v-for="(item, index) in dycodeList" :key="index">
                    <img :src="item.url" />
                    <p>{{item.name}}</p>
                  </div>
                </div>
                <div class="foot_outtwo" slot="reference">
                  <span class="iconfont icon-douyin foot_icon"></span>
                  <p style="margin-top: 6px;">抖音</p>
                </div>
              </el-popover>
            </div>
          </div>
          <div class="phonefoot">
            <div v-if="wxcodeList.length>0">
              <p class="foot_title">微信</p>
              <div class="product_categray">
                <div class="categray_wrap" :style="[{width: windowWidth+'px'}]">
                  <ul class="flex categray_ul">
                    <li v-for="(item, index) in wxcodeList" :key="index">
                        <img :src="item.url" @click="previewImg(item.url)" />
                        <div>{{item.name}}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-if="dycodeList.length>0">
              <p class="foot_title">抖音</p>
              <div class="product_categray">
                <div class="categray_wrap" :style="[{width: windowWidth+'px'}]">
                <ul class="flex categray_ul">
                  <li v-for="(item, index) in dycodeList" :key="index">
                    <img :src="item.url" @click="previewImg(item.url)" />
                    <div>{{item.name}}</div>
                  </li>
                </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="foot_copyright">
          <span @click="gotoLinkbeian">Copyright©哥弟商元贸易有限公司版权所有 鄂ICP备2020021026号</span>
        </p>
      </div>
      <van-popup v-model="showScancode" closeable position="center"
        :style="{ borderRadius: '10px' }">
        <div class="scancode_wrap flexcenter flexcolumn">
          <img class="codeimg" :src="qrCodeurl" />
        </div>
      </van-popup>
    </div>
</template>

<script>
  import { bottomBarbaseapi } from "@/api/apilist/commonApi";
  export default {
    props:{
      pageUrl: {
        type:String,
         default: ''
      }
    },
      data() {
        return {
          showScancode: false,//查看大图
          qrCodeurl: '',//图片路径
          cateCurrent: 0,
          windowWidth: 1200,
          dycodeList: [],
          wxcodeList: [],
          footerInfo: {
            linkList: [],
            componyInfo: {
            }
          }
        };
      },
      async fetch() {
        // console.log('底部的')
        // let info = window.sessionStorage.getItem('footerInfo');
        // if(info){
        //   this.footerInfo = info;
        // }else{
          // let bottomBarbaseapi = await bottomBarbaseapi()
          // console.log('哈哈哈哈',bottomBarbaseapi)
        // }
      },
      created() {
        if(this.pageUrl=='home'){
          window.sessionStorage.setItem('footerInfo', '');
        }
        this.getbasebottomList()
      },
      mounted(){
        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
                //浏览器变化执行动作
          this.windowWidth = window.innerWidth
        });
      },
      methods: {
        previewImg(url){
          this.qrCodeurl = url;
          this.showScancode = true;
        },
        gotoLinkbeian(){
          window.open('https://beian.miit.gov.cn', "_blank");
        },
        gotoLink(item){
          if(item.linkUrl){
            window.open(item.linkUrl, "_blank");
          }
        },
        getbasebottomList() {
          let info = window.sessionStorage.getItem('footerInfo');
          if(info){
            this.footerInfo = JSON.parse(info);
            this.footerInfo.bottomInfo.forEach((item)=>{
              if(item.configKey=='web.company.dyInfo'){
                let configValue = JSON.parse(item.configValue);
                if(configValue.show==1){
                  this.dycodeList = configValue.list;
                }
              }else if(item.configKey=='web.company.wxInfo'){
                let configValue = JSON.parse(item.configValue);
                if(configValue.show==1){
                  this.wxcodeList = configValue.list;
                }
              }
            })
          }else{
            bottomBarbaseapi().then(res=>{
              let componyInfo = {};
              res.data.bottomInfo.forEach((item)=>{
                if(item.configKey=='web.company.kfWx'){
                  componyInfo.kfWx = item.configKey;
                  componyInfo.kfWxValue = item.configValue;
                }else if(item.configKey=='web.company.workTime'){
                  componyInfo.workTime = item.configKey;
                  componyInfo.workTimeValue = item.configValue;
                }else if(item.configKey=='web.company.xzMobile'){
                  componyInfo.xzMobile = item.configKey;
                  componyInfo.xzMobileValue = item.configValue;
                }else if(item.configKey=='web.company.dyInfo'){
                  componyInfo.dyInfo = item.configKey;
                  let configValue = JSON.parse(item.configValue);
                  if(configValue.show==1){
                    this.dycodeList = configValue.list;
                  }
                }else if(item.configKey=='web.company.wxInfo'){
                  componyInfo.wxInfo = item.configKey;
                  let configValue = JSON.parse(item.configValue);
                  if(configValue.show==1){
                    this.wxcodeList = configValue.list;
                  }
                }else if(item.configKey=='web.company.address'){
                  componyInfo.address = item.configKey;
                  componyInfo.addressValue = item.configValue;
                }else if(item.configKey=='web.company.logo'){
                  componyInfo.logo = item.configKey;
                  componyInfo.logoValue = item.configValue;
                }else if(item.configKey=='web.company.kfMobile'){
                  componyInfo.kfMobile = item.configKey;
                  componyInfo.kfMobileValue = item.configValue;
                }
              })
              res.data.componyInfo = componyInfo;
              this.footerInfo = res.data;
              window.sessionStorage.setItem('footerInfo', JSON.stringify(res.data));
            })
          }

        },
        handleClick(tab, event) {
          // console.log(tab._props.name, event);
          this.$emit('handleClick', tab._props.name)
        }
      }
    };
</script>

<style scoped lang="less">
  .foot_section{
    width: 100%;
    background-color: #F2F2F2;
      .link_item{ margin-right: 33px;
        span{border-bottom: 1px solid #989898;color: #222222;margin-top: 2px;cursor: pointer;}
      }
      .foot_online{color: #D9BF81;margin-left: 10px;cursor: pointer;}

      .foot_telline{margin-bottom: 12px;}
      .foot_icon{font-size: 80px;color: #222222;line-height: 80px;}
      .foot_copyright{margin-top: 42px;
        span{cursor: pointer;}
      }
      .foot_outtwo{margin-left: 50px;cursor: pointer;}
      .foot_outone{cursor: pointer;}


  }
  .pover_code{
    padding: 15px;
    text-align: center;
    font-size: 14px;
    color: #999;
    img{width: 120px;height: 120px;margin-bottom: 10px;}
  }
  @media screen and (max-width: 480px){
    .pconline{display: none;}
    .pcfoot{display: none;}
    .scancode_wrap{padding: 40px 20px 20px;width: 250px;}
    .codeimg{width: 210px;height: 210px;}
    .foot_wrap{padding: 20px 15px 44px;font-size: 14px;}
    .foot_flex{text-align: center;}
    .foot_logo{height: 30px;}
    .foot_href{ font-weight: bold;padding: 20px 0 0;font-size: 16px; }
    .link_item{ margin-top: 10px;}
    .foot_telbox{margin-bottom: 15px;}
    .foot_concat{ font-weight: bold;margin-bottom: 10px;margin-top: 30px;font-size: 16px; }
    .foot_title{font-size: 16px;font-weight: bold;margin-bottom: 10px;margin-top: 30px;}
    .foot_scrollout{overflow-y: hidden;}
    .product_categray{
      width: 100%;
      height: 160px;
      margin-bottom: 10px;
      overflow: hidden;
      font-size: 14px;
      text-align: center;
      position: relative;
      .categray_wrap{
        height: 180px;
        overflow-x: scroll;
        white-space: nowrap;
        position: absolute;
        // padding-bottom: 10px;
        left: 0;
        top: 0;
        .categray_ul{
          transition: 0.3s;
          li{
            cursor: pointer;
            display: block;
            margin-right: 22px;
            font-size: 16px;
            text-align: left;
            img{
              width: 80px;
              height: 80px;
              margin-bottom: 6px;
            }
            div{max-width: 220px;white-space: pre-wrap;}
          }
        }
      }
    }

  }
  @media screen and (min-width: 481px){
    .smallonline{display: none;}
    .phonefoot{display: none;}
    .foot_wrap{
      width: 1200px;
      padding: 50px 0 45px;
      margin: 0 auto;
	  font-size: 14px;
    }
    .foot_flex{display: flex;}
    .foot_logo{ height: 50px; }
    .foot_href{ font-weight: bold;padding: 50px 0 22px;font-size: 18px; }
    .foot_outconcat{margin-top: 68px;display: flex;justify-content: space-between;}
    .footflex{display: flex;}
    .foot_telbox{margin-right: 50px;}
    .foot_concat{ font-weight: bold;margin-bottom: 12px;font-size: 18px; }
  }

</style>
